module.exports = __webpack_public_path__ + "static/media/announcement.8accaed8.svg";